import { render, staticRenderFns } from "./QuillView.vue?vue&type=template&id=3b04281a&scoped=true"
import script from "./QuillView.vue?vue&type=script&lang=js"
export * from "./QuillView.vue?vue&type=script&lang=js"
import style0 from "./QuillView.vue?vue&type=style&index=0&id=3b04281a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b04281a",
  null
  
)

export default component.exports